import React from 'react';

import { createRoot } from 'react-dom/client';

import { getDocument } from '@atlaskit/browser-apis';
import { initSentry } from '@atlassian/twg-microsite-experience';
import { consumeEngineUrlOverride } from '@atlassian/twg-microsite-experience/graph-explorer/engine-mode';
import { consumeShowcaseUrlOverride } from '@atlassian/twg-microsite-experience/graph-explorer/showcase-mode';

import { initUFO } from './analytics/react-ufo/initUFO';
import { initializeFeatureGatesAnonymous } from './feature-flags';
import { App } from './ui/App';

// Initialise Sentry before rendering the app.
// Disabled in dev environments (localhost / development / local).
initSentry();

// Initialise React UFO before rendering so the React Profiler subscription
// is in place when the first commit happens.
initUFO();

// Start flags before React mounts. UserProvider waits for them alongside the
// profile request while showing its loading state.
// eslint-disable-next-line @atlaskit/platform/no-module-level-eval
void initializeFeatureGatesAnonymous();

// Turn `?graph=showcase` into a session-scoped override and strip it from the
// address bar, so a demo URL does not have to stay on screen. Runs before
// `root.render` so the explorer's first mount already sees the resolved value —
// it reads showcase mode once and would otherwise keep the pre-strip answer.
consumeShowcaseUrlOverride();

// Same treatment for `?engine=v2`, which selects the bespoke SVG/HTML renderer over
// React Flow. Also before `root.render`, because the explorer resolves the engine on
// its first render and would otherwise keep the pre-strip answer.
consumeEngineUrlOverride();

const rootNode = getDocument()?.getElementById('pillar-root');

if (rootNode !== undefined && rootNode !== null) {
	const root = createRoot(rootNode);
	root.render(<App />);
}
